import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {errorRaised} from "@mnjsplatform/data/lib/actions/errorActions";
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam";
import PlaceholderWrapper from "../Common/PlaceholderWrapper";
import i18next from "i18next";
import PopupWrapper from "../Common/PopupWrapper";

class SalaryRequest extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            isDataReady: false, updateStateFlag: null
        }
    }

    componentDidMount() {
        this.setState({isDataReady: false}, this.initialize);
    }

    async initialize() {
        try {
            await this.props.dispatch(this.props.dataItem.execute(this.props.rowKey ?? {ReqIntId: null}));
            if (this.props.addMode) {
                await this.props.dispatch(this.props.dataItem.beginAdd());
            }
        } catch (e) {
            this.props.dispatch(errorRaised(e));
        } finally {
            this.setState({isDataReady: true});
        }
    }

    close = async () => {
        if (this.props.addMode) {
            await this.props.dispatch(this.props.dataItem.cancelAdd());
        }
        if (this.props.onClose) {
            this.props.onClose(false);
        }
    }
    save = async () => {
        if (this.props.addMode) {
            await this.props.dispatch(this.props.dataItem.saveAdd());
        } else {
            await this.props.dispatch(this.props.dataItem.save());
        }
        if (!this.props.dataItem.isError) {
            if (this.props.onClose) {
                this.props.onClose(true);
            }
        }
    }

    renderButtons = () => {
        return (<div className="modal-footer text-right">
            {!this.props.readOnly && <button type="button" className="btn btn-regular -goahead"
                                             onClick={this.save}>{i18next.t("Salary_Request_1")}</button>}
            <button type="button" className="btn btn-regular -default" data-dismiss="modal"
                    onClick={this.close}>{i18next.t("CloseWithoutSaving")}</button>
        </div>);
    }

    paramRender = (h) => {
        const IsChgBspData = this.props.dataItem.getField(0, "IsChgBspData") && this.props.dataItem.getField(0, "IsChgBspData") === 1;
        const IsChgPatData = this.props.dataItem.getField(0, "IsChgPatData") && this.props.dataItem.getField(0, "IsChgPatData") === 1;
        return (<>
            <PlaceholderWrapper placeholderId="IsChgBspData" canCollapse={false} showSplitterLine={false}
                                showHeaderTitle={false} showInstruction={false}>
                <div style={{cursor: "pointer"}}>
                    <input type="checkbox" className="checkbox align-baseline" checked={IsChgBspData}
                           data-toggle="toggle"
                           disabled={this.props.readOnly} readOnly={this.props.readOnly}
                           id="checkIsChgBspData"
                           style={{cursor: "pointer"}}
                           onChange={async () => {
                               await this.props.dispatch(this.props.dataItem.setField(0, "IsChgBspData", IsChgBspData ? 0 : 1));
                               this.setState({updateStateFlag: Date.now()})
                           }}/>&nbsp;
                    <label htmlFor="checkIsChgBspData" style={{cursor: "pointer"}}>{h.lbl("IsChgBspData")}</label>
                </div>
                <div className="row">
                    <div className="col-md-3 field-title">
                        {h.lbl("BspBankName")}
                    </div>
                    <div className="col-md-9">
                        {h.ed("BspBankName", {readOnly: !IsChgBspData})}
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-3 field-title">
                        {h.lbl("BspOpenNew")}
                    </div>
                    <div className="col-md-9">
                        {h.ed("BspOpenNew", {readOnly: !IsChgBspData})}
                    </div>
                </div>
            </PlaceholderWrapper>
            <PlaceholderWrapper placeholderId="IsChgPatData" canCollapse={false} showSplitterLine={false}
                                showHeaderTitle={false} showInstruction={false}>
                <div style={{cursor: "pointer"}}>
                    <input type="checkbox" className="checkbox align-baseline" checked={IsChgPatData}
                           data-toggle="toggle"
                           id="checkIsChgPatData"
                           disabled={this.props.readOnly} readOnly={this.props.readOnly}
                           style={{cursor: "pointer"}}
                           onChange={async () => {
                               await this.props.dispatch(this.props.dataItem.setField(0, "IsChgPatData", IsChgPatData ? 0 : 1));
                               this.setState({updateStateFlag: Date.now()})
                           }}/>&nbsp;
                    <label htmlFor="checkIsChgPatData" style={{cursor: "pointer"}}>{h.lbl("IsChgPatData")}</label>
                </div>
                <div className="row">
                    <div className="col-md-3 field-title">
                        {h.lbl("PatNumAcc")}
                    </div>
                    <div className="col-md-4">
                        {h.ed("PatNumAcc", {readOnly: !IsChgPatData})}
                    </div>
                    <div className="col-md-2 field-title">
                        {h.lbl("PatMirPay")}
                    </div>
                    <div className="col-md-3">
                        {h.ed("PatMirPay", {readOnly: !IsChgPatData})}
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-3 field-title">
                        {h.lbl("PatBankCode")}
                    </div>
                    <div className="col-md-9">
                        {h.ed("PatBankCode", {readOnly: !IsChgPatData})}
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-3 field-title">
                        {h.lbl("PatNumCard")}
                    </div>
                    <div className="col-md-9">
                        {h.ed("PatNumCard", {readOnly: !IsChgPatData})}
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-3 field-title">
                        {h.lbl("_ScanExistInfo")}
                    </div>
                    <div className="col-md-9">
                        {h.ed("_ScanExistInfo", {readOnly: !IsChgPatData})}
                    </div>
                </div>
            </PlaceholderWrapper>
        </>)
    }

    render() {
        if (!this.state.isDataReady) return null;

        return <PopupWrapper popupVisible={true} title={i18next.t("Salary_Request_2")}
                             onClose={this.close} renderButtons={this.renderButtons}>
            <ComplexParam dataItem={this.props.dataItem} readOnly={this.props.readOnly} showApplyButton={false}
                          showSearchBar={false}
                          renderParams={this.paramRender}
                          updateStateFlag={this.state.updateStateFlag}/>
        </PopupWrapper>
    }
}

SalaryRequest.propTypes = {
    dispatch: PropTypes.func.isRequired, dataItem: PropTypes.object, onClose: PropTypes.func, readOnly: PropTypes.bool
}
SalaryRequest.defaultProps = {};

function mapStateToProps(state, ownProps) {
    return {
        dataItem: state.salaryProjectState.BspPersReq_POx_ReqOne
    }
}

export default connect(mapStateToProps)(SalaryRequest)